import { AspectRatio } from "@/components/ui/aspect-ratio";
import { cn } from "@/lib/utils";
import { Skeleton } from "@/components/ui/skeleton";

export default function MobileCardSkeleton(props: any) {
  const { isSelected } = props;

  if (isSelected) {
    return (
      <div className="">
        <AspectRatio ratio={84 / 71} className={cn("relative")}>
          <Skeleton className="absolute inset-0" />
        </AspectRatio>
        <div className="absolute pt-10">
          <Skeleton className="mb-4 h-8 w-3/4" />
          <Skeleton className="mb-2 h-6 w-1/2" />
          <Skeleton className="h-4 w-full" />
          <Skeleton className="mt-2 h-4 w-3/4" />
        </div>
      </div>
    );
  }

  return (
    <AspectRatio ratio={100 / 71} className={cn("relative")}>
      <Skeleton className="absolute inset-0" />
    </AspectRatio>
  );
}
